import Api from '../../api'
import axios from '@/js/api'
import date from '../../js/date.js'
// import Vue from 'vue'
// import { Message } from 'element-ui'

// function setSlider() {
// 	let dataArr = [];
// 	let data = new Date();
// 	let year = data.getFullYear();
// 	data.setMonth(data.getMonth() + 1, 1) //获取到当前月份,设置月份
// 	for (let i = 0; i < 12; i++) {
// 		data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
// 		let m = data.getMonth() + 1;
// 		m = m < 10 ? "0" + m : m;
// 		dataArr.push(data.getFullYear() + "/" + (m))

// 	}
// 	let obj = {}
// 	dataArr.reverse().forEach((item, index) => {

// 		obj[parseInt((index * .9) * 10)] = item
// 	})

// 	return obj

// };

// function setSlider1() {
// 	let dataArr = [];
// 	let data = new Date();
// 	let year = data.getFullYear();
// 	data.setMonth(data.getMonth() + 1, 1) //获取到当前月份,设置月份
// 	for (let i = 0; i < 12; i++) {
// 		data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
// 		let m = data.getMonth() + 1;
// 		//m = m < 10 ? "0" + m : m;
// 		if (i == 0) {
// 			dataArr.push(data.getFullYear() + "/" + (m))
// 		} else if (i == 11) {
// 			dataArr.push(data.getFullYear() + "/" + (m))
// 		} else {
// 			dataArr.push("" + (m))
// 		}

// 	}
// 	let obj = {}

// 	dataArr.reverse().forEach((item, index) => {
// 		obj[parseInt((index * .9) * 10)] = item
// 	})
// 	return obj
// };
// let sliderMarks = setSlider()
// let sliderMarks1 = setSlider1()
const state = {
	sliderMarks: date.sliderMarks,
	slider: {
		value: [0, 99],
		//value:[72,99],
		marks: date.sliderMarks,
		marks1: date.sliderMarks1
	},
	regionsList: [],
	setDate: {
		startdt: '',
		enddt: '',
	},
	setDateArr: {
		data: []
	},
	HospitalAVGScoreArr: {
		type: '2',
		regionId: '',
		sortType: 2
	},
	DoctorsAvgScoreArr: {
		hospitalGuid: '', //医院编号
		type: 2, //Type 2审核医生3技师
		regionId: '',
		sortType: 2,
		pageIndex: 1,
		pageCount: 10
	},
	total: 0,
	HospitalAVGScoreBtn: {
		average: true,
		deduct: false,
		doctor: true,
		technician: false

	},
	//机构排名
	HospitalAVGScore: [],
	//机构医生排名和医院排名状态 0全部改变 1影像中心 2医生排名
	InstitutionalRanking: {
		type: 0
	},
	HospitalAVGScoreName: {
		name:'全国',
		condition:'平均分',
		type:'诊断医生',
		rank:'排名',
		region:'影像中心',
		makeUp:''
	},
	DoctorsAvgScoreName:{
		name:'全国',
		condition:'平均分',
		type:'诊断医生',
		rank:'排名',
		makeUp:''
	},
	HospitalAVGScores: {
		Max: {
			AvgScore: '',
			HospitalName: ''
		},
		Min: {
			AvgScore: '',
			HospitalName: ''
		},
		Worst: {
			HospitalName: '',
			ReportCount: 0
		}
	},
	DoctorsAvgScore: [],
	
	DoctorsAvgScores: {
		Max: {
			HospitalName: '',
			DoctorName: "",
			AvgScore: "0",

		},
		Min: {
			HospitalName: '',
			DoctorName: "",
			AvgScore: "0",
		},
		Worst: {
			HospitalName: '',
			DoctorName: "",
			ReportCount: "0",
		}
	},
	trigger: {
		hospital: false,
		doctor: false,
		numberPie: false,
		tree: false,
		regions: false,
		//排名类型  false影像中心 true区域排名
		regionsData: false,
	},
	//是否显示影像机构
	isShowEcharts: {
		hospital: true,
	},
	SummaryArr: {
		regionId: '', //区域编号
		hospitalGuid: '', //医院编号
		type: 2, //影像//报告
		startdt: '', //开始时间
		enddt: '', //结束时间
		doctorGuid: '',
		doctorName: ''
	},
	Summary: [],
	SummaryTotalReportCount: 0,
	ReportList: [],
	treeDefault: {
		expanded: [],
		checked: '',
	},
	InitUniqueId: '',
	doctorsAvgScorelist: [],
	loading: true,
	tableloading: true,
	isRightPie: {
		pie: true
	},
	HospitalAVGTypeName: {
		name: 2
	},
	formInlines: {
		OldPassword: '',
		NewPassword: '',
		checkPass: ''
	},
	//密码弹框开关
	dialogVisible: {
		open: false
	},
	zoneBtn: {
		type: true
	},
	sortOrderType: 2,
	//合格医生列表显示
	qualifiedDocType: false,
	QualifiedList: [],
	QualifiedPart: {
		pageCount: 10,
		PageIndex: 1,
		total: 0
	},
	doctorShowType: {
		type: 1
	},
	GetReportListArr: {},
	DoctorsAvgScoreNamejudge: '',
	reportCountList: {
		TotalHospitalCount: '',
		TotalDoctorCount: '',
		StatusCode: '',
	},
	//面包屑内容设置
	breadcrumbList: [],
	destroy: {
		flag: true
	},
	regionType:{
		type:0,
		HospitalGuid:''
	},
	hospitalRankLoading:false,
	allDoctorRankLoading:false,
	// 判断在什么情况下点击的面包屑
	memoryFlag:{
		flag:true
	}
};
const getters = {

};
const mutations = {
	// 全国影像中心排名loading
	sethospitalRankLoading(state, val){
		state.hospitalRankLoading = val;
	},
	// 全国医生排名loading
	setallDoctorRankLoading(state, val){
		state.allDoctorRankLoading = val;
	},
	setSetDate(state, arr){
		state.setDate.startdt = arr.data[0];
		state.setDate.enddt = arr.data[1];
	},
	setHospitalregionId(state, arr){
		state.HospitalAVGScoreArr.regionId = arr;
	},
	clearHospitalAVGScoreArr(state, arr){
		state.HospitalAVGScoreArr.pageIndex = arr;
	},
	currentChangesSecond(state, arr){
		state.QualifiedPart.PageIndex = arr;
	},
	clearPass(state, arr) {
		state.formInlines = {
			OldPassword: '',
			NewPassword: '',
			checkPass: ''
		}
	},
	setBreadcrumbList(state, arr) {
		state.breadcrumbList = [];
	},
	doctorShowTypeChange(state, arr) {
		state.doctorShowType.type = arr;
	},
	sortOrderTypeChange(state, arr) {
		state.sortOrderType = arr;
	},
	zoneBtnChange(state, arr) {
		if (state.treeDefault.checked == 'a446dbc7-bf21-48ce-b3a5-115ff5aebcc1') {
			state.zoneBtn.type = true;
		} else {
			state.zoneBtn.type = false;
		}
	},
	setLoading(state, arr) {
		state.loading = arr;
	},
	settableLoading(state, arr) {
		state.tableloading = arr;
	},
	resetPassword(state, arr) {
		state.formInlines.OldPassword = '';
		state.formInlines.NewPassword = '';
		state.formInlines.checkPass = '';
	},
	ChangePassType(state, arr) {
		if (arr.data.StatusCode == 200) {
			ELEMENT.Message.success(arr.data.Msg)
		}
		state.dialogVisible.open = false;
	},
	setSplitScreen(state, arr) {
		if (arr == 1) {
			state.splitScreen = true;
			state.qualifiedDocType = false;
		} else if (arr == 2) {
			state.splitScreen = true;
			state.qualifiedDocType = true;
		} else {
			state.splitScreen = false;
			state.qualifiedDocType = false;
		}
	},
	setqualifiedDoc(state, arr) {
		state.qualifiedDocType = arr;
	},
	// 设置默认日期
	initDate(state, val){
		//设置默认日期
		state.setDate.enddt = state.slider.marks[state.slider.value[1]]
		state.setDate.startdt = state.slider.marks[state.slider.value[0]]
		// state.HospitalAVGScoreName.name = '全国排名';
		// state.DoctorsAvgScoreName.name = '全国医生排名';
	},
	//机构树
	SetRegions(state, arr) {
		state.setDateArr.data = [];
		//设置默认日期
		state.setDate.enddt = state.slider.marks[state.slider.value[1]]
		state.setDate.startdt = state.slider.marks[state.slider.value[0]]
		state.setDateArr.data.push(state.setDate.startdt);
		state.setDateArr.data.push(state.setDate.enddt);
		//设置默认参数
		state.HospitalAVGScoreArr.regionId = arr.data.Regions[0].UniqueId;
		state.InitUniqueId = arr.data.Regions[0].UniqueId;
		//判断是否显示切换
		let regions = arr.data.RegionCount > 1 ? true : false;
		state.trigger.regions = regions;
		state.regionsList = arr.data.Regions;
		state.trigger.tree = true;
		state.treeDefault.checked = arr.data.Regions[0].UniqueId;

		//重新登录时候情况筛选条件
		state.HospitalAVGScoreBtn.average = true;
		state.HospitalAVGScoreBtn.deduct = false;
		state.HospitalAVGScoreArr.type = 2;
		state.trigger.regionsData = false;
		state.HospitalAVGScoreArr.sortType = 2;
	},
	setDateArrMu(state, arr) {
		state.setDateArr.data = arr;
	},
	//影像机构平均分排名
	SetHospitalAVGScore(state, res) {
		state.trigger.hospital = true;
		if (res.data.Hospitals) {
			// state.trigger.regionsData = false;
			state.HospitalAVGScore = res.data.Hospitals;
		}
		//选择区域排名时
		if (res.data.Regions) {
			// state.trigger.regionsData = true;
			state.HospitalAVGScore = res.data.Regions;
			state.HospitalAVGScore.forEach(res=>{
				res.RegionType = 2;
			})
		}

		//影像中心名字
		// state.HospitalAVGScoreName = res.data.CurrentName;

		if (res.data.Max != undefined) {
			state.HospitalAVGScores.Max = res.data.Max;
			state.HospitalAVGScores.Min = res.data.Min;
		}

		if (res.data.Worst != undefined) {
			state.HospitalAVGScores.Worst = res.data.Worst;
		}
		state.ReportList = [];
	},
	setHospitalAVGScoreBtn(state, arr) {
		if (arr == 'average') {
			state.HospitalAVGScoreBtn.average = true;
			state.HospitalAVGScoreBtn.deduct = false;
			state.isRightPie.pie = true;
		}
		if (arr == 'deduct') {
			state.HospitalAVGScoreBtn.average = false;
			state.HospitalAVGScoreBtn.deduct = true;
		}
	},
	//医生排行榜
	SetDoctorsAvgScore(state, res) {
		state.trigger.doctor = true;
		state.treeDefault.expanded = [];
		state.total = res.data.TotalCount;
		if (state.HospitalAVGScoreArr.regionId) {
			state.treeDefault.expanded = state.HospitalAVGScoreArr.regionId.split(',')
		}
		//医生地区名字
		if (res.data.Doctors) {
			state.DoctorsAvgScore = res.data.Doctors;
			state.DoctorsAvgScores.Max = res.data.Max;
			state.DoctorsAvgScores.Min = res.data.Min;
		}
		if (res.data.Hospitals) {
			state.DoctorsAvgScore = res.data.Hospitals;
			state.DoctorsAvgScores.Worst = res.data.Worst;
		}
		state.doctorsAvgScorelist = res.data.Hospitals;
	},
	//质控个数总数
	SetSummaryCount(state, arr) {
		state.reportCountList.TotalHospitalCount = arr.data.TotalHospitalCount;
		state.reportCountList.TotalDoctorCount = arr.data.TotalDoctorCount;
		state.reportCountList.TotalReportCount = arr.data.TotalReportCount;
	},
	//质控个数
	SetSummary(state, arr) {
		state.Summary = arr.data;
		state.SummaryTotalReportCount = arr.data.TotalReportCount;
		let color1 = ['#7CCACB', '#648CB3', '#A79393', '#755765', '#37BFA7', '#F2F0EE'];
		let color2 = ['#725A7A', '#C56D86', '#FF7582', '#355C7D', '#849FAD', '#FFE29F', '#58B6E6', '#FCCC68', '#FD9D70',
			'#9AC1FB', '#E2D07D'
		];
		let color3 = ['#F08583', '#91ABA3', '#B4E2C4', '#F6F3CF', '#F6BDB3', '#806154', '#2B538F', '#69C2C1', '#ECD8C1',
			'#B37470', '#47655B', '#B1D082'
		];
		if (state.Summary.ModalityTypes) {
			state.Summary.ModalityTypes.map((res, index) => {
				res.color = color1[index]
			})
		}
		if (state.Summary.ScanTypes) {
			state.Summary.ScanTypes.map((res, index) => {
				res.color = color2[index]
			})
		}
		if (state.Summary.BodyParts) {
			state.Summary.BodyParts.map((res, index) => {

				res.color = color3[index]
			})
		}
		state.trigger.numberPie = true;
	},
	//严重扣分项
	// SetReportList(state, arr) {
	// 	state.doctorsAvgScorelist.map(res => {
	// 		if (res.DoctorName == arr.data.Reports[0].DoctorName) {
	// 			res.children = arr.data.Reports;
	// 		}
	// 	})
	// },
	//合格列表
	SetQualifiedList(state, arr) {
		state.QualifiedList = arr.data.Reports;
		state.QualifiedPart.total = arr.data.TotalCount;
	},
	//右侧饼图显示隐藏
	isRightPiemu(state, arr) {
		if (state.HospitalAVGScoreBtn.deduct) {
			state.isRightPie.pie = false;
		} else {
			state.isRightPie.pie = true;
		}
	},
	//修改右侧饼图title
	SetDoctorTitleName(state, arr) {
		if (arr) {
			state.DoctorsAvgScoreNamejudge = arr.doctorName;
		} else {
			state.DoctorsAvgScoreNamejudge = state.DoctorsAvgScoreName;
		}
	},
	setDoctorsAvgScoreName(state, val){
		state.DoctorsAvgScoreName.makeUp = val;
	}
};
const actions = {
	//修改密码
	ChangePasswordAct({
		state,
		commit,
	}) {
		state.formInlines.UserGuid = JSON.parse(localStorage.getItem('user')).sid;
		axios.ajaxPost('post', Api.api.login.ChangePassword, state.formInlines).then(res => {
			commit('ChangePassType', res);
		})
	},
	// 监察员树层级
	GetRegions({
		state,
		commit,
		dispatch
	}, {
		params
	}) {
		return axios.ajaxGet('get', Api.api.supervisor.GetRegions).then(res => {
				commit('SetRegions', res);
				commit('zoneBtnChange', res);
				// dispatch('GetHospitalAVGScore');
				// dispatch('GetDoctorsAvgScore');
				// dispatch('GetSummary');
				commit('setLoading', false)
			})
			.finally(() => {

			});
	},
	// //监察数层级
	// GetRegions({
	// 	state,
	// 	commit,
	// 	dispatch
	// }) {
	// 	axios.ajaxGet('get', Api.api.supervisor.GetRegions).then(res => {
	// 		commit('SetRegions', res);
	// 		commit('zoneBtnChange', res);
	// 		dispatch('GetHospitalAVGScore');
	// 		commit('setLoading', false)
	// 	})
	// },
	//影像机构平均分排名
	GetHospitalAVGScore({
		state,
		commit,
		dispatch
	}) {
		commit('sethospitalRankLoading', true)
		// if (state.InstitutionalRanking.type != 1) {
		// 	commit('setallDoctorRankLoading', true)
		// }
		state.HospitalAVGScoreArr.startdt = state.setDate.startdt;
		state.HospitalAVGScoreArr.enddt = state.setDate.enddt;
		axios.ajaxGet('get', Api.api.supervisor.GetHospitalAVGScore, state.HospitalAVGScoreArr).then(res => {
			commit('SetHospitalAVGScore', res);
			// //不是影像中心排名
			// if (state.InstitutionalRanking.type != 1) {
			// 	dispatch('GetDoctorsAvgScore')
			// }
			commit('sethospitalRankLoading', false)
			commit('setLoading', false)
		})
	},
	//监察员报告列表
	GetReportList({
		state,
		commit
	}, arr) {
		commit('setLoading', true)
		axios.ajaxPost('post', Api.api.supervisor.GetReportList, {
			samplingTaskGuid: arr.samplingTaskGuid, //任务ID
			hospitalGuid: arr.hospitalGuid, //医院ID
			regionId: state.HospitalAVGScoreArr.regionId,
			type: state.HospitalAVGScoreArr.type,
			doctorGuid: '', //医生编号
			doctorName: arr.doctorName, //医生名字
			isUnqualified: arr.isUnqualified,
			isSerious: arr.isSerious,
			startdt: state.setDate.startdt,
			enddt: state.setDate.enddt,
			pageIndex: state.QualifiedPart.PageIndex,
			pageCount: 10,
			modalityType: arr.modalityType,
			scanType: arr.scanType,
			bodypart: arr.bodypart,
			scoreType:arr.scoreType,
			itemDesc:arr.itemDesc,
			AccNo:arr.AccNo
		}).then(res => {
			commit('setLoading', false)
			commit('SetQualifiedList', res)
			//不合格
			// if (arr.isUnqualified) {
			// 	commit('SetReportList', res)
			// }
		})
	},
	//影像机构扣分排名
	GetHospitalUnqualifiedReport({
		state,
		commit,
		dispatch
	}) {
		state.HospitalAVGScoreArr.startdt = state.setDate.startdt;
		state.HospitalAVGScoreArr.enddt = state.setDate.enddt;
		axios.ajaxGet('get', Api.api.supervisor.GetHospitalUnqualifiedReport, state.HospitalAVGScoreArr).then(res => {
			commit('SetHospitalAVGScore', res)
			dispatch('GetDoctorUnqualifiedReport')
			commit('setLoading', false)
		})
	},
	//医生平均分排名
	GetDoctorsAvgScore({
		state,
		commit,
		dispatch
	}) {
		commit('setallDoctorRankLoading', true)
		state.DoctorsAvgScoreArr.startdt = state.setDate.startdt;
		state.DoctorsAvgScoreArr.enddt = state.setDate.enddt;
		state.DoctorsAvgScoreArr.regionId = state.HospitalAVGScoreArr.regionId;
		state.DoctorsAvgScoreArr.type = state.HospitalAVGScoreArr.type;
		state.DoctorsAvgScoreArr.sortType = state.HospitalAVGScoreArr.sortType;

		axios.ajaxGet('get', Api.api.supervisor.GetDoctorsAvgScore, state.DoctorsAvgScoreArr).then(res => {
			commit('SetDoctorsAvgScore', res)
			commit('setallDoctorRankLoading', false)
			commit('settableLoading', false)
			// dispatch('GetSummary')
		})
	},
	//不合格医生排行
	GetDoctorUnqualifiedReport({
		state,
		commit,
		dispatch
	}) {
		commit('setallDoctorRankLoading', true)
		state.DoctorsAvgScoreArr.startdt = state.setDate.startdt;
		state.DoctorsAvgScoreArr.enddt = state.setDate.enddt;
		state.DoctorsAvgScoreArr.regionId = state.HospitalAVGScoreArr.regionId;
		state.DoctorsAvgScoreArr.type = state.HospitalAVGScoreArr.type;
		state.DoctorsAvgScoreArr.sortType = state.HospitalAVGScoreArr.sortType;
		axios.ajaxGet('get', Api.api.supervisor.GetDoctorUnqualifiedReport, state.DoctorsAvgScoreArr).then(res => {
			commit('SetDoctorsAvgScore', res)
			// dispatch('GetSummary')
			commit('setallDoctorRankLoading', false)
			commit('setLoading', false)
		})
	},

	//质控个数
	GetSummary({
		state,
		commit
	}, arr) {
		state.SummaryArr.startdt = state.setDate.startdt;
		state.SummaryArr.enddt = state.setDate.enddt;
		state.SummaryArr.regionId = state.HospitalAVGScoreArr.regionId;

		state.SummaryArr.type = state.HospitalAVGScoreArr.type;
		if (arr) {
			state.SummaryArr.doctorGuid = arr.doctorGuid;
			state.SummaryArr.doctorName = arr.doctorName;
			state.SummaryArr.hospitalGuid = arr.hospitalGuid;
		} else {
			state.SummaryArr.doctorGuid = '';
			state.SummaryArr.doctorName = '';
			state.SummaryArr.hospitalGuid = state.DoctorsAvgScoreArr.hospitalGuid;
		}
		axios.ajaxGet('get', Api.api.supervisor.GetSummary, state.SummaryArr).then(res => {
			commit('SetSummary', res);
			commit('SetDoctorTitleName', arr);
			commit('setLoading', false);
		})
	},
	// 总数量
	GetCount({
		state,
		commit
	}) {
		axios.ajaxGet('get', Api.api.supervisor.GetCount, state.SummaryArr).then(res => {
			commit('SetSummaryCount', res);
			commit('setLoading', false);
		})
	},
	//合格区域排名
	GetRegionAVGScore({
		state,
		commit
	}) {
		axios.ajaxGet('get', Api.api.supervisor.GetRegionAVGScore, {
			type: state.HospitalAVGScoreArr.type,
			startdt: state.setDate.startdt,
			enddt: state.setDate.enddt,
			sortType: state.HospitalAVGScoreArr.sortType,

		}).then(res => {
			commit('SetHospitalAVGScore', res);
			commit('setLoading', false)
		})
	},
	//不合格区域排名
	GetRegionUnqualifiedReport({
		state,
		commit
	}) {
		axios.ajaxGet('get', Api.api.supervisor.GetRegionUnqualifiedReport, {
			type: state.HospitalAVGScoreArr.type,
			regionId: state.HospitalAVGScoreArr.regionId,
			sortType: state.HospitalAVGScoreArr.sortType,
			startdt: state.setDate.startdt,
			enddt: state.setDate.enddt,
		}).then(res => {
			commit('SetHospitalAVGScore', res);
			commit('setLoading', false)

		})
	}

}
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
